// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Common = require("../utils/Common.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

function createDisjGroups(disj, intToSym, intToTyp, typeOrder) {
  var disjMut = MM_context.disjMake();
  Belt_MapInt.forEach(disj, (function (n, ms) {
          Belt_SetInt.forEach(ms, (function (m) {
                  MM_context.disjAddPair(disjMut, n, m);
                }));
        }));
  var resArr = [];
  MM_context.disjForEachArr(disjMut, true, (function (i) {
          var match = intToSym(i);
          return match[0];
        }), intToTyp, Caml_option.some(typeOrder), (function (grp) {
          resArr.push(grp.map(intToSym));
        }));
  return resArr;
}

function makeInitialState(preCtx, frame, typeColors, typeOrderInDisj) {
  var frmCtx = MM_context.createContext(Caml_option.some(preCtx), undefined);
  var symRename = {
    contents: undefined
  };
  var frmVarIntToCtxInt = [];
  var symColors = Belt_HashMapString.make(frame.numOfVars);
  var createLocalCtxVar = function (frmVarName, typInt) {
    var match = MM_context.generateNewVarNames(frmCtx, [typInt], Caml_option.some(undefined), undefined);
    if (match.length !== 1) {
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "MM_cmp_pe_frame_summary_state.res",
              55,
              12
            ],
            Error: new Error()
          };
    }
    var ctxVarName = match[0];
    var match$1 = MM_context.generateNewLabels(frmCtx, "loc-var-", 1, undefined, undefined);
    if (match$1.length !== 1) {
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "MM_cmp_pe_frame_summary_state.res",
              61,
              12
            ],
            Error: new Error()
          };
    }
    var ctxVarLabel = match$1[0];
    MM_context.applySingleStmt(frmCtx, {
          TAG: "Var",
          symbols: [ctxVarName]
        }, undefined, undefined, undefined, undefined);
    MM_context.applySingleStmt(frmCtx, {
          TAG: "Floating",
          label: ctxVarLabel,
          expr: [
            MM_context.ctxIntToSymExn(frmCtx, typInt),
            ctxVarName
          ]
        }, undefined, undefined, undefined, undefined);
    var symRename$1 = symRename.contents;
    if (symRename$1 !== undefined) {
      Belt_HashMapString.set(Caml_option.valFromOption(symRename$1), ctxVarName, frmVarName);
    } else {
      var map = Belt_HashMapString.make(frame.numOfVars);
      Belt_HashMapString.set(map, ctxVarName, frmVarName);
      symRename.contents = Caml_option.some(map);
    }
    return MM_context.ctxSymToIntExn(frmCtx, ctxVarName);
  };
  for(var frmVarInt = 0 ,frmVarInt_finish = frame.numOfVars; frmVarInt < frmVarInt_finish; ++frmVarInt){
    var frmVarName = frame.frameVarToSymb[frmVarInt];
    var match = MM_context.getTokenType(frmCtx, frmVarName);
    var ctxVarName;
    var exit = 0;
    if (match === "V") {
      var ctxVarInt = MM_context.ctxSymToIntExn(frmCtx, frmVarName);
      var ctxVarTypInt = MM_context.getTypeOfVarExn(frmCtx, ctxVarInt);
      if (frame.varTypes[frmVarInt] === ctxVarTypInt) {
        frmVarIntToCtxInt.push(ctxVarInt);
        ctxVarName = frmVarName;
      } else {
        var ctxNewVarInt = createLocalCtxVar(frmVarName, frame.varTypes[frmVarInt]);
        frmVarIntToCtxInt.push(ctxNewVarInt);
        ctxVarName = MM_context.ctxIntToSymExn(frmCtx, ctxNewVarInt);
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var ctxNewVarInt$1 = createLocalCtxVar(frmVarName, frame.varTypes[frmVarInt]);
      frmVarIntToCtxInt.push(ctxNewVarInt$1);
      ctxVarName = MM_context.ctxIntToSymExn(frmCtx, ctxNewVarInt$1);
    }
    var frmVarTypSym = MM_context.ctxIntToSymExn(frmCtx, frame.varTypes[frmVarInt]);
    Belt_Option.forEach(Belt_HashMapString.get(typeColors, frmVarTypSym), (function(ctxVarName){
        return function (color) {
          Belt_HashMapString.set(symColors, ctxVarName, color);
        }
        }(ctxVarName)));
  }
  var frameIntToCtxInt = function (i) {
    if (i < 0) {
      return i;
    } else {
      return frmVarIntToCtxInt[i];
    }
  };
  var disj = Belt_MapInt.size(frame.disj) > 0 ? createDisjGroups(frame.disj, (function (i) {
            var sym = MM_context.ctxIntToSymExn(frmCtx, frameIntToCtxInt(i));
            return [
                    sym,
                    Belt_HashMapString.get(symColors, sym)
                  ];
          }), (function (i) {
            return MM_context.getTypeOfVar(frmCtx, frameIntToCtxInt(i));
          }), typeOrderInDisj) : undefined;
  return {
          frmCtx: frmCtx,
          symColors: symColors,
          eHyps: frame.hyps.filter(function (hyp) {
                  return hyp.typ === "E";
                }).map(function (hyp) {
                return hyp.expr.map(frameIntToCtxInt);
              }),
          asrt: frame.asrt.map(frameIntToCtxInt),
          symRename: symRename.contents,
          descrIsExpanded: false,
          disj: disj
        };
}

function toggleDescrIsExpanded(st) {
  return {
          frmCtx: st.frmCtx,
          symColors: st.symColors,
          eHyps: st.eHyps,
          asrt: st.asrt,
          symRename: st.symRename,
          descrIsExpanded: !st.descrIsExpanded,
          disj: st.disj
        };
}

function rndDisjGrp(grp) {
  var res = [];
  for(var i = 0 ,i_finish = grp.length; i < i_finish; ++i){
    if (i > 0) {
      res.push(React.createElement("span", {
                key: "s-" + String(i),
                style: {
                  color: "black",
                  fontFamily: "monospace",
                  fontSize: "1.3em",
                  fontWeight: "normal"
                }
              }, " "));
    }
    var match = grp[i];
    var tmp = {
      fontFamily: "monospace",
      fontSize: "1.3em",
      fontWeight: "bold"
    };
    var tmp$1 = match[1];
    if (tmp$1 !== undefined) {
      tmp.color = tmp$1;
    }
    res.push(React.createElement("span", {
              key: "v-" + String(i),
              style: tmp
            }, match[0]));
  }
  return res;
}

var disjGrpDelim = Common.nbsp + Common.nbsp + Common.nbsp + Common.nbsp;

function rndDisj(disj) {
  var disjGrpArr = [];
  for(var i = 0 ,i_finish = disj.length; i < i_finish; ++i){
    var grp = disj[i];
    if (i > 0) {
      disjGrpArr.push(React.createElement("span", {
                key: "s-" + String(i),
                style: {
                  display: "inline-block",
                  minWidth: "20px"
                }
              }));
    }
    disjGrpArr.push(React.createElement("span", {
              key: "g-" + String(i),
              style: {
                border: "1px solid grey",
                paddingRight: "3px",
                paddingLeft: "3px",
                borderRadius: "5px"
              }
            }, rndDisjGrp(grp)));
  }
  return disjGrpArr;
}

exports.makeInitialState = makeInitialState;
exports.toggleDescrIsExpanded = toggleDescrIsExpanded;
exports.createDisjGroups = createDisjGroups;
exports.disjGrpDelim = disjGrpDelim;
exports.rndDisj = rndDisj;
/* react Not a pure module */
